"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PhoneSmsConfirmationInfo = require("./PhoneSmsConfirmationInfo");
Object.keys(_PhoneSmsConfirmationInfo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PhoneSmsConfirmationInfo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PhoneSmsConfirmationInfo[key];
    }
  });
});